import React from "react";
import { money } from "../../dashboardHelpers";

// Card-row list (icon avatar + label + count + amount) with a highlighted
// Total footer - this app's established "card-rows, not DataTable, for
// on-screen reports" convention, matching Flutter's own _MiniSummaryTable.
const MiniSummaryTable = ({ title, icon, rows }) => {
  const totalCount = rows.reduce((s, r) => s + r.count, 0);
  const totalAmount = rows.reduce((s, r) => s + r.amount, 0);

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="mb-3">
      <div className="text-muted small fw-semibold mb-1">{title}</div>
      <div className="mini-summary-list">
        {rows.map((r) => (
          <div className="mini-summary-row" key={r.code + r.label}>
            <span className="mini-summary-row-icon">{icon}</span>
            <span className="mini-summary-row-label">{r.label}</span>
            <span className="text-muted small me-2">{r.count}</span>
            <span className="fw-semibold small">{money(r.amount)}</span>
          </div>
        ))}
        <div className="mini-summary-row mini-summary-total">
          <span className="mini-summary-row-label fw-semibold">Total</span>
          <span className="text-muted small me-2">{totalCount}</span>
          <span className="fw-bold small">{money(totalAmount)}</span>
        </div>
      </div>
    </div>
  );
};

export default MiniSummaryTable;
